import React from 'react';
type LogoSize = 'sm' | 'md' | 'lg';
interface LogoProps {
  className?: string;
  dark?: boolean;
  size?: LogoSize;
}
const logoSizes: Record<LogoSize, {
  icon: number;
  gap: string;
  wordmark: string;
}> = {
  sm: {
    icon: 20,
    gap: 'gap-2',
    wordmark: 'text-base'
  },
  md: {
    icon: 26,
    gap: 'gap-2.5',
    wordmark: 'text-xl'
  },
  lg: {
    icon: 46,
    gap: 'gap-4',
    wordmark: 'text-4xl'
  }
};
export function Logo({
  className = '',
  dark = false,
  size = 'md'
}: LogoProps) {
  const textColor = dark ? 'text-white' : 'text-navy';
  const triColor = dark ? '#38BDF8' : '#2563EB';
  const scale = logoSizes[size];
  return <div className={`flex items-center ${scale.gap} ${className}`} aria-label="PRISMA" data-id="element-34" data-mp="dsxvfn5q06au">
      <svg width={scale.icon} height={Math.round(scale.icon * 24 / 26)} viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-35" data-mp="hsqa8hlpj8on">
        <path d="M13 2 L24 22 L2 22 Z" stroke={triColor} strokeWidth="2.4" strokeLinejoin="round" data-id="element-36" data-mp="32ljz48mk4kfx" />
      </svg>
      <span className={`font-bold tracking-tight ${scale.wordmark} leading-none ${textColor}`} data-id="element-37" data-mp="19wgbzim9w0z0">
        PRISMA
      </span>
    </div>;
}